import one from './orders'
import two from './orders/view'

export const OrdersList: any = one
export const OrderDetails: any = two
